import WhitelistCard from './WhitelistCard'

export default WhitelistCard
